<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <aip-dip-layout class="table" />
        </div>
        <button class="btn btn-back btn-outline-secondary" @click="goBack">
          Back
        </button>
        <button
          class="btn btn-resubmit btn-danger"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#resubmitPackageModal"
          @click="resubmitPackage"
          :disabled="buttonDisabled()"
        >
          Resubmit Package
        </button>
      </div>
    </div>
  </div>
  <resubmit-package-modal :selected-id="selectedSipId" :selected-status="selectedStatus" :selected-package-type="selectedPackageType"/>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import ResubmitPackageModal from "@/components/Modal/ResubmitPackageModal.vue";
import AipDipLayout from "@/components/Search/Layout/AipDipLayout.vue";
import { useTypesenseStore } from "@/stores/typesense";
import { useAsyncState } from "@vueuse/core";
import { ref } from "vue";
import { useRouter } from "vue-router";

const typesenseStore = useTypesenseStore();
const type = ref("secure-zone-packages");
const selectedSipId = ref("");
const selectedStatus = ref("");
const selectedPackageType = ref("");
const router = useRouter();

const goBack = () => {
  router.push({ name: "search" });
};

const resubmitPackage = () => {
  selectedSipId.value = typesenseStore.currentContent.sip_uuid;
  selectedStatus.value = typesenseStore.currentContent.status;
  selectedPackageType.value = typesenseStore.currentContent.type;
};

const buttonDisabled = () => {
  if(typesenseStore.currentContent.status == "Stalled") {
    return false;
  } else return true;
}

var current_uuid = router.currentRoute.value.params.selectedSearchId.toString();
const serverParams = ref({
  filter_by: "uuid:=" + current_uuid,
  sort_by: "",
  q: "*",
  query_by: "uuid", // can include more fields.
});

const { execute, error } = useAsyncState(() => {
  return typesenseStore.fetchTypesense(
    type.value,
    serverParams.value
  );
}, null);
</script>

<style scoped>
.btn-resubmit {
  margin-top: 10px;
  margin-left: 2%;
  width: 46%;
  margin-bottom: 8px;
}
.btn-back {
  margin-top: 10px;
  margin-left: 2%;
  width: 46%;
  margin-bottom: 8px;
}
</style>
